import { Component, OnInit } from '@angular/core'
import { Router } from "@angular/router"
import { HttpClient } from '@angular/common/http'
import { DynamicDialogRef, TreeNode } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/api';
import { MessageService } from 'primeng/api';
import 'rxjs/add/operator/debounceTime';
import { environment } from 'src/environments/environment';
import { Periodicity } from 'src/app/Models/Handbooks/Periodicity';
import { Industry } from 'src/app/Models/Industry';
import { Indicator } from 'src/app/Models/Indicator'
import { ReformatIndustry } from './Helpers';
import { MeasureUnit } from 'src/app/Models/Handbooks/MeasureUnit';
import { SourceSystem } from 'src/app/Models/Handbooks/SourceSystem';
import { InformationSource } from 'src/app/Models/Handbooks/InformationSource';
import { ReferencedDocument } from 'src/app/Models/Handbooks/ReferencedDocument';
import { CurrentLangPipe } from 'src/app/Pipes/CurrentLangPipe';
import { TranslatePipe } from 'src/app/Pipes/TranslatePipe';

@Component({
    selector: 'app-indicator-edit',
    templateUrl: './IndicatorEdit.html',
    styleUrls: ['./style.less'],
    providers: [MessageService, CurrentLangPipe, TranslatePipe]
})
export class IndicatorEditComponent implements OnInit {

    IsLoading: boolean = true;

    //#region http obtain handbooks
    getPeriodicities() {
        return this.http.get(`${environment.apiUrl}/api/Periodicities/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    getMeasureUnits() {
        return this.http.get(`${environment.apiUrl}/api/MeasureUnits/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    getReferencedDocumentsUnits() {
        return this.http.get(`${environment.apiUrl}/api/ReferencedDocuments/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    getInformationSources() {
        return this.http.get(`${environment.apiUrl}/api/InformationSources/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    getSourceSystems() {
        return this.http.get(`${environment.apiUrl}/api/SourceSystems/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    getIndustries() {
        return this.http.get(`${environment.apiUrl}/api/Industries/Tree`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    //#endregion

    getIndicator() {
        return this.http.get(`${environment.apiUrl}/api/Indicators/Get/${this.config.data.id}`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    SaveChanges() {
        this.UpdatingBool = true;
        this.http.put(`${environment.apiUrl}/api/Indicators/Update/${this.Current.Id}`, JSON.stringify({
            TaldauIdentifier: this.Current.TaldauIdentifier,
            NameRu: this.Current.NameRu,
            NameEn: this.Current.NameEn,
            NameKz: this.Current.NameKz,
            AlternativeNameRu: this.Current.AlternativeNameRu,
            AlternativeNameEn: this.Current.AlternativeNameEn,
            AlternativeNameKz: this.Current.AlternativeNameKz,
            CommentRu: this.Current.CommentRu,
            CommentEn: this.Current.CommentEn,
            CommentKz: this.Current.CommentKz,
            MinValue: this.Current.MinValue,
            MaxValue: this.Current.MaxValue,
            IsDeviedByRegions: this.Current.IsDeviedByRegions,
            PeriodicityId: this.Current.PeriodicityId,
            MeasureUnitId: this.Current.MeasureUnitId,
            IndustryId: this.Current.IndustryId,
            InformationSourceId: this.Current.InformationSourceId,
            SourceSystemId: this.Current.SourceSystemId,
            ReferencedDocumentsIds: this.Current.ReferencedDocumentsIds,

            IsPlannedAvailable: this.Current.IsPlannedAvailable,
            IsPositive: this.Current.IsPositive,
            IsVerified: this.Current.IsVerified,
            IsObsolete: this.Current.IsObsolete,
            IsPublic: this.Current.IsPublic,
        }), {
            headers: {
                "Content-Type": "application/json",
            }
        }).subscribe(
            (data: Indicator) => {
                this.messageService.add({
                    severity: 'success',
                    summary: this.translatePipe.transform('warnings.saved'),
                    detail: this.translatePipe.transform('warnings.indicatorInformationIsSaved')
                });
                this.UpdatingBool = false;
            },
            err => {
                this.UpdatingBool = false;
            },
            () => {
                this.UpdatingBool = false;
            }
        )
    }

    UpdatingBool: boolean = false;

    Current: Indicator = new Indicator();
    Reserved: Indicator = new Indicator();

    //#region handbooks fields ang reformatted getters
    Periodicities: Periodicity[] = [];
    get PeriodicitiesOptions(): Array<any> {
        return this.Periodicities.map((x) => ({
            label: (this.CurrentLang == 'ru') ? x.NameRu : ((this.CurrentLang == 'kk') ? x.NameKz : x.NameEn),
            value: x.Id
        }))
    }

    MeasureUnits: MeasureUnit[] = [];
    get MeasureUnitsOptions(): Array<any> {
        return this.MeasureUnits.map((x) => ({
            label: (this.CurrentLang == 'ru') ? x.NameRu : ((this.CurrentLang == 'kk') ? x.NameKz : x.NameEn),
            value: x.Id
        }))
    }

    ReferencedDocuments: ReferencedDocument[] = [];
    get ReferencedDocumentsOptions(): Array<any> {
        return this.ReferencedDocuments.map((x) => ({
            label: (this.CurrentLang == 'ru') ? x.NameRu : ((this.CurrentLang == 'kk') ? x.NameKz : x.NameEn),
            value: x.Id
        }))
    }

    SourceSystems: SourceSystem[] = [];
    get SourceSystemsOptions(): Array<any> {
        return this.SourceSystems.map((x) => ({
            label: (this.CurrentLang == 'ru') ? x.NameRu : ((this.CurrentLang == 'kk') ? x.NameKz : x.NameEn),
            value: x.Id
        }))
    }

    InformationSources: InformationSource[] = [];
    get InformationSourcesOptions(): Array<any> {
        return this.InformationSources.map((x) => ({
            label: (this.CurrentLang == 'ru') ? x.NameRu : ((this.CurrentLang == 'kk') ? x.NameKz : x.NameEn),
            value: x.Id
        }))
    }

    Industries: Array<Industry> = [];
    IndustriesSelectedNodes: TreeNode[] = [];
    IndustriesTreeForSphere: TreeNode[] = [];
    //#endregion

    DeselectIndustries() {
        this.IndustriesSelectedNodes = [];
    }

    constructor(private http: HttpClient,
        //private route: ActivatedRoute,
        private router: Router,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private messageService: MessageService,
        private currentLangPipe: CurrentLangPipe,
        private translatePipe: TranslatePipe,
        // private cookieService: CookieService
    ) { }

    CurrentLang: string = 'ru';

    ngOnInit() {
        this.CurrentLang = this.currentLangPipe.get()
        this.getIndustries().subscribe((data: Array<Industry>) => {
            this.Industries = data;
            this.IndustriesTreeForSphere = this.Industries.map(x => ReformatIndustry(x, this.CurrentLang, true));
            this.IndustriesTreeForSphere = this.IndustriesTreeForSphere.map(x => {var _s = x; _s.selectable = false; return _s;});

            this.getMeasureUnits().subscribe((data: Array<MeasureUnit>) => { this.MeasureUnits = data; })
            this.getReferencedDocumentsUnits().subscribe((data: Array<ReferencedDocument>) => { this.ReferencedDocuments = data; })
            this.getSourceSystems().subscribe((data: Array<SourceSystem>) => { this.SourceSystems = data; })
            this.getInformationSources().subscribe((data: Array<InformationSource>) => { this.InformationSources = data; })

            this.getPeriodicities().subscribe((data: Array<Periodicity>) => {
                this.Periodicities = data

                this.getIndicator().subscribe((data: Indicator) => {
                    this.Current = data;
                    // this.Reserved = {...data};
                    // this.Reserved.IndustryTreeSelected = {...this.Current.IndustryTreeSelected}

                    this.Current.IndustryTreeSelected = this._deepFilter(this.IndustriesTreeForSphere, this.Current.IndustryId);
                    this.IsLoading = false;
                })

            })

        })
        
    }

    _deepFilter (tree: TreeNode[], id: number, _result: TreeNode = null): TreeNode {
        for (var x of tree) {
            if (x.children.length > 0) {
                _result = this._deepFilter(x.children, id, _result);
            } else {
                if (parseInt(x.data) == id) {
                    _result = x;
                    this._expandToParents(_result);
                    break;
                }
            }
        }
        return _result
    }

    _expandToParents(node: TreeNode) {
        if (node != null) {
            node.expanded = true;
            if (node.parent != null) {
                this._expandToParents(node.parent);
            }
        }
    }

    doubleFilter: RegExp =  /^-?(?:0|[1-9]\d{0,2}(?:,?\d{3})*)(?:\.\d+)?$/;

    UndoChanges() {
        this.Current = {...this.Reserved};
    }

    CurrentIndustryChanged() {
        this.Current.IndustryId = this.Current.IndustryTreeSelected.data
    }

}